// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./company.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./detail.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./goals.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!./header-banner.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!./history.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js!./location.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js!./notice.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js!./products.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../node_modules/css-loader/dist/cjs.js!./registration.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../node_modules/css-loader/dist/cjs.js!./esg.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../node_modules/css-loader/dist/cjs.js!./manager.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../node_modules/css-loader/dist/cjs.js!./safety.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/environmental.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/social.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/governance.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* 이헐게 연결하면 main.css 만 사용 하면되고 필요하면 따로 파일 만들어서 사용 하면됨  */
  @charset "UTF-8";

  /* 메인 */
  .main {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    margin-top: 20px;
  }

  .main-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
  }

  .main-content {
    position: absolute;
    bottom: 50%;
    right: 0;
    /* transform: translateX(-50%); */
    text-align: center;
  }

  .main-btn {
    display: inline-block;
    padding: 15px 40px;
    font-size: 1.2rem;
    font-weight: bold;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    border: 2px solid #fff;
    border-radius: 30px;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .main-btn:hover {
    background: #fff;
    color: #000;
  }

  /* 섹션 */
  /* 2025.10.27 class 수정 */
  .products {
    padding: 80px 20px;
    max-width: 1200px;
    margin: auto;
  }

  .company {
    padding: 80px 20px;
    max-width: 1200px;
    margin: auto;
  }

  .esg {
    padding: 80px 20px;
    max-width: 1200px;
    margin: auto;
  }

  /* 2025.10.28 css 수정 */
  /* 2025.10.30 */
  .support {
    padding: 80px 20px;
    max-width: 1200px;
    margin: auto;
  }

  .text > h2 {
    margin: 0px;
    padding-bottom: 12px;
  }

  h2 {
    margin-bottom: 20px;
  }

  .text>h4 {
    font-size: 24px;
    margin: 0px;
    padding-bottom: 12px;
  }

  .text>p {
    font-weight: 700;
    font-size: 18px;
  }

  /* 제품 */
  .products {
    text-align: left;
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
  }

  /* 2025.10.15 padding 수정 */
  .slider-container {
    position: relative;
    overflow: hidden;
    padding: 24px 50px;
  }

  .slider {
    display: flex;
    gap: 30px;
    transition: transform 0.5s ease-in-out;
  }

  .slide {
    flex: 0 0 calc(50% - 15px);
    box-sizing: border-box;
  }

  /* 2025.10.15 nav-btn 수정 */
  .nav-btn {
    position: absolute;
    top: 60%;
    background: #9c9c9c;
    border: 1px solid #acacac;
    padding: 15px;
    border-radius: 10%;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }

  .nav-btn:hover {
    background: #7e7e7e;
  }


  .nav-btn {
    top: 64%;
    padding: 10px;
  }

  .nav-btn svg path {
    fill: #fff;
  }

  .prev {
    left: 10px;
    /* 이미지 바깥쪽 */
  }

  .next {
    right: 19px;
  }

  /* 제품 반응형 */
  @media (max-width: 768px) {
    .slide {
      flex: 0 0 100%;
    }
  }

  /* 슬라이드 카드 */
  .card {
    border: 1px solid #ddd;
    padding: 20px;
    border-radius: 8px;
    background: #f9f9f9;
    text-align: center;
    height: 400PX;
  }

  .slider>div {
    width: 400px;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: #fff;
  }

  .slider>div>img {
    height: 100%;
    object-fit: cover;
  }

  /* 2025.10.15 company css 추가 */
  .company {
    display: flex;
    justify-content: space-between;
  }

  .company-img {
    flex: 1;
    text-align: right;
    max-width: 60%;
  }

  .company-img>img {
    width: 100%;
    height: auto;
    max-height: 600px;
    border-radius: 8px;
    object-fit: cover;
    object-position: 50% 40%;
  }

  @media (max-width: 768px) {
    .company {
      flex-direction: column;
    }

    .company-img {
      max-width: 100%;
      margin-top: 20px;
    }
  }

  /* 2025.10.15 esg 추가 */
  .esg .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-top: 40px;
  }

  /* 2025.10.21 esg css 추가 */
  .esg {
    padding: 60px 20px 100px;
    max-width: 1200px;
    margin: 0 auto;
  }

  /* ---------------------- */

  .esg .card {
    position: relative;
    height: 420px;
    border-radius: 12px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    color: white;
    transition: transform 0.3s ease, filter 0.3s ease;
  }

  .esg .card:hover {
    transform: translateY(-6px);
    filter: brightness(1.1);
  }

  /* 배경 이미지 */
  .card.environment {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

  .card.social {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }

  .card.governance {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

  .overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 32px;
    border-radius: inherit;
    transition: 0.3s ease;
  }

  .card:hover .overlay {
    background: rgba(0, 0, 0, 0.5);
  }

  .overlay h5 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
    opacity: 0.8;
    transform: translateY(50px);
    transition: transform 0.4s ease;
  }

  .overlay h3 {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 12px;
    transform: translateY(50px);
    transition: transform 0.4s ease;
  }

  .overlay p {
    font-size: 15px;
    line-height: 1.6;
    max-width: 280px;
    opacity: 0;
    transform: translateY(15px);
    transition: opacity 0.4s ease, transform 0.4s ease;
    text-align: center;
    margin: 0 auto;
    display: block;
  }

  .card:hover .overlay h5,
  .card:hover .overlay h3 {
    transform: translateY(-10px);
  }

  .card:hover .overlay p {
    opacity: 1;
    transform: translateY(0);
  }

  .esg .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-top: 40px;
  }

  /* 2025.10.15 esg 반응형 추가 */
  @media (max-width: 1024px) {
    .esg .grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 768px) {
    .esg .grid {
      grid-template-columns: 1fr;
      /* 한 줄씩 세로 배치 */
      gap: 20px;
    }

    .esg .card {
      height: 320px;
      /* 카드 높이 축소 */
    }

    .overlay {
      padding: 24px;
    }

    .overlay h3 {
      font-size: 22px;
    }

    .overlay p {
      font-size: 14px;
      max-width: 100%;
    }

    /* 중앙정렬 + 점 제거 */
ul.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  list-style: none;
  padding: 20px 0;
  margin: 0;
}

    /* 링크 기본 파란색/밑줄 제거 + 폰트 통일 */
    ul.pagination a,
    ul.pagination a:link,
    ul.pagination a:visited,
    ul.pagination a:hover,
    ul.pagination a:active {
      color: #000;               /* 전부 검정 */
      text-decoration: none;     /* 기본 밑줄 제거 */
      font-size: 17px;           /* 폰트 크기 통일 */
      line-height: 1;
      display: inline-block;
    }

    /* 활성 페이지만 밑줄 */
    ul.pagination li.active > a {
      text-decoration: underline;
      font-weight: 600;
    }

    /* 비활성 스타일 */
    ul.pagination li.disabled > a {
      opacity: 0.35;
      pointer-events: none;
    }
    ul.pagination a:contains("‹"),
    ul.pagination a:contains("›") {
      font-size: 26px; /* 화살표 크게 */
    }
  }

  /* 중앙정렬 + 점 제거 */
ul.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  list-style: none;
  padding: 20px 0;
  margin: 0;
}

/* 링크 기본 파란색/밑줄 제거 + 폰트 통일 */
ul.pagination a,
ul.pagination a:link,
ul.pagination a:visited,
ul.pagination a:hover,
ul.pagination a:active {
  color: #000;               /* 전부 검정 */
  text-decoration: none;     /* 기본 밑줄 제거 */
  font-size: 17px;           /* 폰트 크기 통일 */
  line-height: 1;
  display: inline-block;
}

/* 활성 페이지만 밑줄 */
ul.pagination li.active > a {
  text-decoration: underline;
  font-weight: 600;
}

/* 비활성 스타일 */
ul.pagination li.disabled > a {
  opacity: 0.35;
  pointer-events: none;
}
ul.pagination a:contains("‹"),
ul.pagination a:contains("›") {
  font-size: 26px; /* 화살표 크게 */
}

  /* 공지사항 class 변경 */
  /* 공지사항 */
  /* 2025.10.28 공지사항 삭제 */
  /* .main-notice {
    margin-top: 15px;
  }

  .main-notice li {
    border-bottom: 1px solid #ddd;
    padding: 8px 0;
    list-style: none;
  } */`, "",{"version":3,"sources":["webpack://./static/css/main.css"],"names":[],"mappings":"EAAE,wDAAwD;EACxD,gBAAgB;;EAchB,OAAO;EACP;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA,OAAO;EACP,wBAAwB;EACxB;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;EACd;;EAEA,sBAAsB;EACtB,eAAe;EACf;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,OAAO;EACP;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;EAChB;;EAEA,0BAA0B;EAC1B;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,sCAAsC;EACxC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA,0BAA0B;EAC1B;IACE,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA,WAAW;EACX;IACE;MACE,cAAc;IAChB;EACF;;EAEA,YAAY;EACZ;IACE,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA,8BAA8B;EAC9B;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,OAAO;IACP,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B;IACE,wBAAwB;IACxB,iBAAiB;IACjB,cAAc;EAChB;;EAEA,2BAA2B;;EAE3B;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;IACZ,iDAAiD;EACnD;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA,WAAW;EACX;IACE,yDAAkD;EACpD;;EAEA;IACE,yDAA2C;EAC7C;;EAEA;IACE,yDAA+C;EACjD;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B,kDAAkD;IAClD,kBAAkB;IAClB,cAAc;IACd,cAAc;EAChB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE,0BAA0B;MAC1B,eAAe;MACf,SAAS;IACX;;IAEA;MACE,aAAa;MACb,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,eAAe;IACjB;;IAEA,gBAAgB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;IAEI,4BAA4B;IAC5B;;;;;MAKE,WAAW,gBAAgB,UAAU;MACrC,qBAAqB,MAAM,aAAa;MACxC,eAAe,YAAY,aAAa;MACxC,cAAc;MACd,qBAAqB;IACvB;;IAEA,eAAe;IACf;MACE,0BAA0B;MAC1B,gBAAgB;IAClB;;IAEA,YAAY;IACZ;MACE,aAAa;MACb,oBAAoB;IACtB;IACA;;MAEE,eAAe,EAAE,WAAW;IAC9B;EACF;;EAEA,gBAAgB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA,4BAA4B;AAC5B;;;;;EAKE,WAAW,gBAAgB,UAAU;EACrC,qBAAqB,MAAM,aAAa;EACxC,eAAe,YAAY,aAAa;EACxC,cAAc;EACd,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;;EAEE,eAAe,EAAE,WAAW;AAC9B;;EAEE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB;;;;;;;;KAQG","sourcesContent":["  /* 이헐게 연결하면 main.css 만 사용 하면되고 필요하면 따로 파일 만들어서 사용 하면됨  */\n  @charset \"UTF-8\";\n  @import url(company.css);\n  @import url(detail.css);\n  @import url(goals.css);\n  @import url(header-banner.css);\n  @import url(history.css);\n  @import url(location.css);\n  @import url(notice.css);\n  @import url(products.css);\n  @import url(registration.css);\n  @import url(esg.css);\n  @import url(manager.css);\n  @import url(safety.css);\n\n  /* 메인 */\n  .main {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n    margin-top: 20px;\n  }\n\n  .main-video {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    z-index: -1;\n  }\n\n  .main-content {\n    position: absolute;\n    bottom: 50%;\n    right: 0;\n    /* transform: translateX(-50%); */\n    text-align: center;\n  }\n\n  .main-btn {\n    display: inline-block;\n    padding: 15px 40px;\n    font-size: 1.2rem;\n    font-weight: bold;\n    color: #fff;\n    background: rgba(0, 0, 0, 0.5);\n    border: 2px solid #fff;\n    border-radius: 30px;\n    text-decoration: none;\n    transition: all 0.3s ease;\n  }\n\n  .main-btn:hover {\n    background: #fff;\n    color: #000;\n  }\n\n  /* 섹션 */\n  /* 2025.10.27 class 수정 */\n  .products {\n    padding: 80px 20px;\n    max-width: 1200px;\n    margin: auto;\n  }\n\n  .company {\n    padding: 80px 20px;\n    max-width: 1200px;\n    margin: auto;\n  }\n\n  .esg {\n    padding: 80px 20px;\n    max-width: 1200px;\n    margin: auto;\n  }\n\n  /* 2025.10.28 css 수정 */\n  /* 2025.10.30 */\n  .support {\n    padding: 80px 20px;\n    max-width: 1200px;\n    margin: auto;\n  }\n\n  .text > h2 {\n    margin: 0px;\n    padding-bottom: 12px;\n  }\n\n  h2 {\n    margin-bottom: 20px;\n  }\n\n  .text>h4 {\n    font-size: 24px;\n    margin: 0px;\n    padding-bottom: 12px;\n  }\n\n  .text>p {\n    font-weight: 700;\n    font-size: 18px;\n  }\n\n  /* 제품 */\n  .products {\n    text-align: left;\n    position: relative;\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n\n  /* 2025.10.15 padding 수정 */\n  .slider-container {\n    position: relative;\n    overflow: hidden;\n    padding: 24px 50px;\n  }\n\n  .slider {\n    display: flex;\n    gap: 30px;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  .slide {\n    flex: 0 0 calc(50% - 15px);\n    box-sizing: border-box;\n  }\n\n  /* 2025.10.15 nav-btn 수정 */\n  .nav-btn {\n    position: absolute;\n    top: 60%;\n    background: #9c9c9c;\n    border: 1px solid #acacac;\n    padding: 15px;\n    border-radius: 10%;\n    cursor: pointer;\n    z-index: 10;\n    transition: all 0.3s ease;\n  }\n\n  .nav-btn:hover {\n    background: #7e7e7e;\n  }\n\n\n  .nav-btn {\n    top: 64%;\n    padding: 10px;\n  }\n\n  .nav-btn svg path {\n    fill: #fff;\n  }\n\n  .prev {\n    left: 10px;\n    /* 이미지 바깥쪽 */\n  }\n\n  .next {\n    right: 19px;\n  }\n\n  /* 제품 반응형 */\n  @media (max-width: 768px) {\n    .slide {\n      flex: 0 0 100%;\n    }\n  }\n\n  /* 슬라이드 카드 */\n  .card {\n    border: 1px solid #ddd;\n    padding: 20px;\n    border-radius: 8px;\n    background: #f9f9f9;\n    text-align: center;\n    height: 400PX;\n  }\n\n  .slider>div {\n    width: 400px;\n    height: 400px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    background-color: #fff;\n  }\n\n  .slider>div>img {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  /* 2025.10.15 company css 추가 */\n  .company {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .company-img {\n    flex: 1;\n    text-align: right;\n    max-width: 60%;\n  }\n\n  .company-img>img {\n    width: 100%;\n    height: auto;\n    max-height: 600px;\n    border-radius: 8px;\n    object-fit: cover;\n    object-position: 50% 40%;\n  }\n\n  @media (max-width: 768px) {\n    .company {\n      flex-direction: column;\n    }\n\n    .company-img {\n      max-width: 100%;\n      margin-top: 20px;\n    }\n  }\n\n  /* 2025.10.15 esg 추가 */\n  .esg .grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n    margin-top: 40px;\n  }\n\n  /* 2025.10.21 esg css 추가 */\n  .esg {\n    padding: 60px 20px 100px;\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n\n  /* ---------------------- */\n\n  .esg .card {\n    position: relative;\n    height: 420px;\n    border-radius: 12px;\n    overflow: hidden;\n    background-size: cover;\n    background-position: center;\n    color: white;\n    transition: transform 0.3s ease, filter 0.3s ease;\n  }\n\n  .esg .card:hover {\n    transform: translateY(-6px);\n    filter: brightness(1.1);\n  }\n\n  /* 배경 이미지 */\n  .card.environment {\n    background-image: url('../img/environmental.webp');\n  }\n\n  .card.social {\n    background-image: url('../img/social.webp');\n  }\n\n  .card.governance {\n    background-image: url('../img/governance.webp');\n  }\n\n  .overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.35);\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    padding: 32px;\n    border-radius: inherit;\n    transition: 0.3s ease;\n  }\n\n  .card:hover .overlay {\n    background: rgba(0, 0, 0, 0.5);\n  }\n\n  .overlay h5 {\n    font-size: 16px;\n    font-weight: 600;\n    margin-bottom: 4px;\n    opacity: 0.8;\n    transform: translateY(50px);\n    transition: transform 0.4s ease;\n  }\n\n  .overlay h3 {\n    font-size: 28px;\n    font-weight: 700;\n    margin-bottom: 12px;\n    transform: translateY(50px);\n    transition: transform 0.4s ease;\n  }\n\n  .overlay p {\n    font-size: 15px;\n    line-height: 1.6;\n    max-width: 280px;\n    opacity: 0;\n    transform: translateY(15px);\n    transition: opacity 0.4s ease, transform 0.4s ease;\n    text-align: center;\n    margin: 0 auto;\n    display: block;\n  }\n\n  .card:hover .overlay h5,\n  .card:hover .overlay h3 {\n    transform: translateY(-10px);\n  }\n\n  .card:hover .overlay p {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  .esg .grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n    margin-top: 40px;\n  }\n\n  /* 2025.10.15 esg 반응형 추가 */\n  @media (max-width: 1024px) {\n    .esg .grid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  @media (max-width: 768px) {\n    .esg .grid {\n      grid-template-columns: 1fr;\n      /* 한 줄씩 세로 배치 */\n      gap: 20px;\n    }\n\n    .esg .card {\n      height: 320px;\n      /* 카드 높이 축소 */\n    }\n\n    .overlay {\n      padding: 24px;\n    }\n\n    .overlay h3 {\n      font-size: 22px;\n    }\n\n    .overlay p {\n      font-size: 14px;\n      max-width: 100%;\n    }\n\n    /* 중앙정렬 + 점 제거 */\nul.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  list-style: none;\n  padding: 20px 0;\n  margin: 0;\n}\n\n    /* 링크 기본 파란색/밑줄 제거 + 폰트 통일 */\n    ul.pagination a,\n    ul.pagination a:link,\n    ul.pagination a:visited,\n    ul.pagination a:hover,\n    ul.pagination a:active {\n      color: #000;               /* 전부 검정 */\n      text-decoration: none;     /* 기본 밑줄 제거 */\n      font-size: 17px;           /* 폰트 크기 통일 */\n      line-height: 1;\n      display: inline-block;\n    }\n\n    /* 활성 페이지만 밑줄 */\n    ul.pagination li.active > a {\n      text-decoration: underline;\n      font-weight: 600;\n    }\n\n    /* 비활성 스타일 */\n    ul.pagination li.disabled > a {\n      opacity: 0.35;\n      pointer-events: none;\n    }\n    ul.pagination a:contains(\"‹\"),\n    ul.pagination a:contains(\"›\") {\n      font-size: 26px; /* 화살표 크게 */\n    }\n  }\n\n  /* 중앙정렬 + 점 제거 */\nul.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  list-style: none;\n  padding: 20px 0;\n  margin: 0;\n}\n\n/* 링크 기본 파란색/밑줄 제거 + 폰트 통일 */\nul.pagination a,\nul.pagination a:link,\nul.pagination a:visited,\nul.pagination a:hover,\nul.pagination a:active {\n  color: #000;               /* 전부 검정 */\n  text-decoration: none;     /* 기본 밑줄 제거 */\n  font-size: 17px;           /* 폰트 크기 통일 */\n  line-height: 1;\n  display: inline-block;\n}\n\n/* 활성 페이지만 밑줄 */\nul.pagination li.active > a {\n  text-decoration: underline;\n  font-weight: 600;\n}\n\n/* 비활성 스타일 */\nul.pagination li.disabled > a {\n  opacity: 0.35;\n  pointer-events: none;\n}\nul.pagination a:contains(\"‹\"),\nul.pagination a:contains(\"›\") {\n  font-size: 26px; /* 화살표 크게 */\n}\n\n  /* 공지사항 class 변경 */\n  /* 공지사항 */\n  /* 2025.10.28 공지사항 삭제 */\n  /* .main-notice {\n    margin-top: 15px;\n  }\n\n  .main-notice li {\n    border-bottom: 1px solid #ddd;\n    padding: 8px 0;\n    list-style: none;\n  } */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
